'use client';

import React from 'react';
import PricingHero from './PricingHero';
import PricingCard from './PricingCard';
import ROICalculator from './ROICalculator';
import ComparisonTable from './ComparisonTable';
import AddOnsSection from './AddOnsSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import TrustSignals from './TrustSignals';

interface Feature {
  name: string;
  included: boolean;
  description?: string;
}

interface PricingPackage {
  name: string;
  description: string;
  price: string;
  period: string;
  features: Feature[];
  isPopular?: boolean;
  ctaText: string;
  ctaLink: string;
  badge?: string;
}

const PricingInteractive = () => {
  const pricingPackages: PricingPackage[] = [
    {
      name: "Starter",
      description: "Perfect voor kleine bedrijven die willen beginnen met AI",
      price: "€1.250",
      period: "/maand",
      ctaText: "Start met Starter",
      ctaLink: "/contact",
      features: [
        { name: "AI Chatbot integratie", included: true },
        { name: "Basis social media automatisering", included: true },
        { name: "E-mail automatisering", included: true },
        { name: "3 standaard integraties", included: true },
        { name: "E-mail support", included: true },
        { name: "1 onboarding sessie", included: true },
        { name: "Basis analytics dashboard", included: true },
        { name: "Maandelijkse updates", included: true },
        { name: "Workflow automatisering", included: false },
        { name: "Telefoon support", included: false },
        { name: "API toegang", included: false },
        { name: "Custom integraties", included: false }
      ]
    },
    {
      name: "Professional",
      description: "Voor groeiende bedrijven die meer willen bereiken",
      price: "€2.500",
      period: "/maand",
      isPopular: true,
      badge: "Meest gekozen",
      ctaText: "Kies Professional",
      ctaLink: "/contact",
      features: [
        { name: "Alles van Starter, plus:", included: true },
        { name: "Geavanceerde social media automatisering", included: true },
        { name: "Workflow automatisering", included: true },
        { name: "10 standaard integraties", included: true },
        { name: "E-mail & telefoon support", included: true },
        { name: "3 onboarding sessies", included: true },
        { name: "Geavanceerde rapportage", included: true },
        { name: "API toegang", included: true },
        { name: "Webhooks", included: true },
        { name: "Maandelijkse reviews", included: true },
        { name: "Real-time monitoring", included: true },
        { name: "Custom AI modellen", included: false }
      ]
    },
    {
      name: "Enterprise",
      description: "Maatwerk oplossingen voor grote organisaties",
      price: "Op maat",
      period: "",
      ctaText: "Neem contact op",
      ctaLink: "/contact",
      features: [
        { name: "Alles van Professional, plus:", included: true },
        { name: "Premium social media automatisering", included: true },
        { name: "Custom AI modellen", included: true },
        { name: "Onbeperkte integraties", included: true },
        { name: "Dedicated account manager", included: true },
        { name: "Onbeperkte training sessies", included: true },
        { name: "Custom dashboards", included: true },
        { name: "White-label oplossingen", included: true },
        { name: "Custom integraties", included: true },
        { name: "Priority support 24/7", included: true },
        { name: "SLA garanties", included: true },
        { name: "Dedicated infrastructuur", included: true }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <PricingHero />
      
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {pricingPackages.map((pkg, index) => (
              <PricingCard
                key={index}
                name={pkg.name}
                description={pkg.description}
                price={pkg.price}
                period={pkg.period}
                features={pkg.features}
                isPopular={pkg.isPopular}
                ctaText={pkg.ctaText}
                ctaLink={pkg.ctaLink}
                badge={pkg.badge}
              />
            ))}
          </div>
        </div>
      </section>

      <ROICalculator />
      <ComparisonTable />
      <AddOnsSection />
      <FAQSection />
      <CTASection />
      <TrustSignals />
    </div>
  );
};

export default PricingInteractive;